import { useRewards } from "@src/contexts";
import { useEffect } from "react";
import { RewardsSummaryCards } from "./RewardsSummaryCard";
import { RewardsTabsLayout } from "./RewardsTabsLayout";
import { Navigation, PageLayout } from "@src/components";
import { BackArrowIcon } from "@src/assets";
import { RoutePath } from "@src/interfaces";

export const RewardsView = () => {
  const { fetchAll } = useRewards();

  useEffect(() => {
    fetchAll(true);
  }, [fetchAll]);

  return (
    <PageLayout
      navigation={
        <Navigation
          leftItems={[
            {
              content: <BackArrowIcon />,
              path: RoutePath.Wallet,
            },
            {
              content: "Rewards",
              disabled: true,
              path: RoutePath.Rewards,
            },
          ]}
        />
      }
    >
      <div className="flex-1 flex flex-col h-full min-h-0 overflow-hidden">
        <RewardsSummaryCards />
        <RewardsTabsLayout />
      </div>
    </PageLayout>
  );
};
